$(document).on('click', '.showModal', function(){
    if($(this).attr('data-modal').indexOf('google.com/maps/')>0){
        var googleMaps = '<iframe src="'+$(this).attr('data-modal')+'" style="border:0;width:100%;height:100%;margin-bottom:-7px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'
        $.colorbox({
            html: googleMaps,
            width: 600,
            maxWidth: "90%",
            height: 600,
            maxHeight: "90%",
            className: "iframeMap",
            onComplete: function() {
                
            },
        });
    }
})